import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import FeatureItem from '../../base/FeatureItem';
import { PINK, PURPLE_LIGHT, PURPLE_TEXT } from '../../../constants/colors';
import Styles from './Steps.styles';

const StepsWrapper = styled.div`
  ${Styles.stepswrapper};
`;

const whiteSettings = {
  primary: PINK,
  secondary: PURPLE_LIGHT,
  border: true,
  isWhite: true,
  button: true
};

const purpleSettings = {
  primary: PURPLE_TEXT,
  secondary: PURPLE_LIGHT,
  border: false,
  isWhite: false,
  button: false
};

/**
 * Steps components
 * @property {Array} items - step items
 * @returns {JSX}
 */
const Steps = ({ items, isPurple }) => {
  return (
    <ThemeProvider theme={isPurple ? purpleSettings : whiteSettings}>
      <StepsWrapper isPurple={isPurple}>
        <div className="container">
          <div className="row" style={{alignItems: 'flex-start'}}>
            {items.map(item => (
              <FeatureItem key={item.title} className="col-12 col-sm-4" {...item} />
            ))}
          </div>
        </div>
      </StepsWrapper>
    </ThemeProvider>
  );
};

Steps.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      bg: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      text: PropTypes.string,
      link: PropTypes.string
    })
  ),
  isPurple: PropTypes.bool
};

export default Steps;
